<template>
  <div class="xc-menu-group">
    <a
      class="xc-menu-item"
      @click.prevent="handleClick"
      :class="data.active?'xc-menu-active':''"
      :href="urlPrefix + data.url"
    >
      <i
        class="icon icon"
        :class="data.icon"
        v-if="data.icon"
      ></i>
      <div
        class="icon"
        v-if="data.iconPath"
        :style="{
                    'background-image':`url(${data.active && data.selectedIconPath?data.selectedIconPath:data.iconPath})`,
                }"
      >
      </div>
      <div class="title">{{data[labelKey]}}</div>
      <div
        class="xc-menu-arrow"
        v-if="haveChildren"
        :class="data.open?'xc-menu-arrow-up':'xc-menu-arrow-down'"
      ></div>
    </a>
    <ul
      v-show="haveChildren && data.open"
      ref="ul"
    >
      <XcMenuItem
        v-for="(item, key) in data.children"
        :data="item"
        :key="key"
        :index="index"
        :labelKey="labelKey"
        :idKey="idKey"
        :urlPrefix="urlPrefix"
        :topId="topId"
        :select="select"
      />
    </ul>
  </div>
</template>


<script>

import { slideDown, slideUp } from '../utils/slide'

export default {
  name: 'XcMenuItem',
  props: {
    index: Number,
    topId: Number,
    active: Boolean,
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    select: Function,
    labelKey: String,
    idKey: String,
    urlPrefix: {
      type: String,
      default: '',
    },
    // 控制子列表的显示隐藏
    // open: false,
  },
  data() {
    return {
      showChild: false,
    }
  },
  created() {

  },
  watch: {
    'data.open'(v) {
      this.$nextTick(() => {
        if (v) {
          slideDown(this.$refs.ul);
        } else {
          slideUp(this.$refs.ul)
        }
      })
    }
  },
  computed: {
    haveChildren() {
      return this.data.children && this.data.children.length
    },
  },
  methods: {
    handleClick() {
      if (this.haveChildren) {
        if (this.data.open) {
          this.$emit('close', this.data);
        } else {
          this.$emit('open', this.data);
        }
      } else {
        console.log('this.topId', this.topId);
        this.select(this.data, this.topId);
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>

